import React from "react";
import { Link } from "react-router-dom";
import "./landing-page.css";
import { FaCheckCircle, FaMapMarkerAlt, FaTag, FaBolt } from "react-icons/fa";
import CategoryList from "../../../components/main-layout-components/category-list/CategoryList";
import {
  getVehicleCategoryAdCount,
} from "../../../services/main-service/mainService";
import useApiService from "../../../hooks/useApiService";
import Spinner from "../../../components/common/spinner/Spinner";
import ThirdPartyAdSpace from "../../../components/common/third-party-ad-space/ThirdPartyAdSpace";
import { getThirdPartyAds } from "../../../services/admin-service/adminService";
import { BannerSpace } from "../../../types/admin-types/adminTypes";
import { ThirdPartyBannerSpace } from "../../../enums/ThirdPartyBannerSpace";
import { useMasterData } from "../../../hooks/useMasterData";

const STATS = [
  { icon: <FaTag size={22} />,         value: "Free",        label: "To Post An Ad"    },
  { icon: <FaBolt size={22} />,        value: "Fast",        label: "Listing Approval" },
  { icon: <FaCheckCircle size={22} />, value: "Verified",    label: "Seller Profiles"  },
  { icon: <FaMapMarkerAlt size={22} />,value: "Island-wide", label: "Coverage"         },
];

function LandingPage() {
  const { masterData, masterDataLoading, masterDataError } = useMasterData();

  const { data: adCount } = useApiService({
    serviceCall: () => getVehicleCategoryAdCount(),
    dependencies: [],
  });

  const { data: thirdPartyAdList } = useApiService({
    serviceCall: () => getThirdPartyAds(null),
    dependencies: [],
  });

  const landingBanner: BannerSpace | undefined = thirdPartyAdList?.find(
    (s: BannerSpace) => s.location === ThirdPartyBannerSpace.LANDING_PAGE
  );

  if (masterDataLoading) return <Spinner />;
  if (masterDataError)   return <p className="text-center py-5">{masterDataError}</p>;

  return (
    <div className="w-100">

      {/* ── Banner ad (if active) ─────────────────────── */}
      {(landingBanner?.ad_presigned_urls?.length ?? 0) > 0 && (
        <div className="bg-white py-2">
          <div className="container">
            <div className="maximum-width mx-auto">
              <ThirdPartyAdSpace
                urls={landingBanner!.ad_presigned_urls}
                aspectRatio={landingBanner!.resolution}
              />
            </div>
          </div>
        </div>
      )}

      {/* ── Hero Section ─────────────────────────────── */}
      <section className="landing-hero">
        <div className="container">
          <div className="maximum-width mx-auto">
            <div className="row align-items-center gy-4">

              {/* Copy */}
              <div className="col-sm-12 col-md-6">
                <p className="landing-hero__eyebrow">The Largest Marketplace in Sri Lanka</p>
                <h1 className="landing-hero__title">
                  Drive Your<br />
                  <span className="landing-hero__title-accent">Future</span>
                </h1>
                <p className="landing-hero__sub">
                  Discover quality vehicles from trusted sellers across Sri Lanka.
                  Transparent pricing, verified listings, seamless buying.
                </p>
                <div className="d-flex gap-3 flex-wrap">
                  <Link to="/ads?page=1" className="btn btn-danger btn-lg px-4">
                    Browse All Ads
                  </Link>
                  <Link to="/create-ad" className="btn btn-outline-danger btn-lg px-4">
                    Post Free Ad
                  </Link>
                </div>
              </div>

              {/* Category tiles */}
              <div className="col-sm-12 col-md-6">
                <div className="landing-categories-wrapper">
                  <p className="section-label mb-3">Browse by Category</p>
                  <CategoryList
                    categoryList={masterData?.VehicleCategories ?? []}
                    adCount={adCount ?? []}
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* ── Stats Bar ────────────────────────────────── */}
      <section className="landing-stats">
        <div className="container">
          <div className="maximum-width mx-auto">
            <div className="row g-0">
              {STATS.map((stat, i) => (
                <div key={i} className="col-6 col-md-3">
                  <div className={`landing-stat-item ${i < STATS.length - 1 ? "landing-stat-item--border" : ""}`}>
                    <div className="landing-stat-icon">{stat.icon}</div>
                    <div className="landing-stat-value">{stat.value}</div>
                    <div className="landing-stat-label">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}

export default LandingPage;
